module.exports = __webpack_public_path__ + "img/jr51.0fa39762.jpg";